import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ValidationError } from '../../common/types';

export interface ErrorValidationContextState {
  allContentErrors: string[];
  designContentErrors: ValidationError[];
  designContentWarnings: ValidationError[];
  hasOtherLocaleError: boolean;
  hasValidationError: boolean;
  isBlastMissingAudience: boolean;
  isFinishedValidating: boolean;
  isSendable: boolean;
  nbaLocalesErrors: string[];
  localeContentErrors: ValidationError[];
  localeContentWarnings: ValidationError[];
  revalidate: (localeTag?: string) => void;
  removeValidation: (localeTag: string) => void;
}

export const defaultState: ErrorValidationContextState = {
  allContentErrors: [],
  designContentErrors: [],
  designContentWarnings: [],
  hasOtherLocaleError: false,
  hasValidationError: false,
  isBlastMissingAudience: false,
  isFinishedValidating: false,
  isSendable: false,
  nbaLocalesErrors: [],
  localeContentErrors: [],
  localeContentWarnings: [],
  revalidate: noop,
  removeValidation: noop,
};

export const ErrorValidationContext = createContext<ErrorValidationContextState>(defaultState);

export const useErrorValidationContext = () => useContext(ErrorValidationContext);
